import {
  ErrorAlert,
  FlexRowCenterVertical,
  Progress,
  StyleUtils,
} from '@main/core-ui';
import React from 'react';
import { useIntl } from 'react-intl';

import { AnimatedEnterExitSingleItem } from '../Animation';
import { Button } from '../Button';
import { Card } from '../Card';
import { humanFileSize } from '../Mimetype';

interface FileListItemProps {
  /** the file to display */
  file: File;
  /** the progress percentage to display (only when loading=true) */
  progressPercent?: number;
  /** is the upload in progress */
  loading?: boolean;
  /** handler when the remove button is clicked. If undefined, button is not shown */
  onRemove?: () => void;
  /** the error for this file */
  error?: string;
}

/**
 * FileListItem
 */
export const FileListItem: React.FC<FileListItemProps> = ({
  file,
  progressPercent,
  onRemove,
  loading,
  error,
}) => {
  const { formatNumber } = useIntl();
  return (
    <Card
      padding={StyleUtils.Spacing.sm}
      style={{ gap: StyleUtils.Spacing.sm }}
      onClick={(e) => {
        e.stopPropagation();
        e.preventDefault();
      }}
    >
      <FlexRowCenterVertical
        style={{
          gap: StyleUtils.Spacing.md,
        }}
      >
        <div style={{ flexGrow: 1 }}>{file.name}</div>
        <div>{humanFileSize(file.size, formatNumber)}</div>
        {onRemove && (
          <Button
            icon="trash"
            iconOnly
            variant="outline-danger"
            disabled={loading}
            onClick={() => {
              onRemove();
            }}
          />
        )}
      </FlexRowCenterVertical>
      <AnimatedEnterExitSingleItem animateHeight>
        {error ? (
          <ErrorAlert noMarginBelow>{error}</ErrorAlert>
        ) : (
          progressPercent !== undefined && (
            <Progress value={Math.round(progressPercent * 100)} />
          )
        )}
      </AnimatedEnterExitSingleItem>
    </Card>
  );
};
